import { css } from "@emotion/react";
import type { Theme } from "@emotion/react";

import * as layers from "@styles/emotion-styles/layers";

export const container = (theme: Theme) => css`
  display: flex;
  width: 80vw;
  padding: 1rem;
  background-color: ${theme.surface.level0};
  position: fixed;
  bottom: 0;
  z-index: ${layers.indexDrawerMax};
`;

export const tabletContainer = css`
  width: 100%;
`;

export const button = css`
  flex-basis: 50%;
`;

export const clearButton = css`
  margin-right: 0.25rem;
`;

export const seeButton = css`
  margin-left: 0.25rem;
`;

export const centered = (theme: Theme) => css`
  justify-content: center;
  background-color: ${theme.system.backgroundMutedHover};
  overflow: hidden;
`;
